import React from 'react';
import { Typography } from '@mui/material';

const Description = (props) => (
  <Typography
    variant='body2' mb={4} color='primary.grey5' {...props}
  />
);

export default Description;
